import { render } from "./CompanyComponent.vue?vue&type=template&id=08c8ee7a"
import script from "./CompanyComponent.vue?vue&type=script&lang=js"
export * from "./CompanyComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Company/CompanyComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08c8ee7a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08c8ee7a', __exports__)) {
    api.reload('08c8ee7a', __exports__)
  }
  
  module.hot.accept("./CompanyComponent.vue?vue&type=template&id=08c8ee7a", () => {
    api.rerender('08c8ee7a', render)
  })

}


export default __exports__